import { createAction, props } from '@ngrx/store';

export const friendList = createAction('FRIEND_LIST', props<{items: any}>());
export const friendCreate = createAction('FRIEND_CREATE', props<{item: any}>());
export const friendUpdate = createAction('FRIEND_UPDATE', props<{item: any}>());
export const friendDelete = createAction('FRIEND_DELETE', props<{item: any}>());
